var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{attrs:{"icon":"","x-small":"","elevation":"0"},on:{"click":function($event){$event.stopPropagation();return _vm.$emit('click')}}},[_c('v-icon',{attrs:{"small":"","color":_vm.$tl_text_color(_vm.elementColor)}},[_vm._t("default",function(){return [_vm._v("mdi-pencil")]})],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }